import { getSafeAnchorHref, hasLinksInField, makeLinksRelative } from '@patrianna/shared-utils/prismic'
import { PrismicRichText } from '@prismicio/react'
import type { JSXFunctionSerializer, JSXMapSerializer } from '@prismicio/react'
import { useRouter } from 'next/navigation'
import type { MouseEvent } from 'react'

import classes from './styles.module.scss'

type RichTextProps = {
  field: string
  components?: JSXMapSerializer | JSXFunctionSerializer
}

function RichText(props: RichTextProps) {
  const router = useRouter()
  const { field, components } = props
  const isTranslationString = typeof field === 'string'
  const isLinksInField = !isTranslationString && hasLinksInField(field)
  const fieldWithCorrectLinksPath = !isTranslationString && makeLinksRelative(field)

  const renderFields = (fieldWithCorrectLinksPath || field) as never

  const handleClick = (e: MouseEvent) => {
    const href = getSafeAnchorHref(e)

    if (href) {
      e.preventDefault()
      router.push(href)
    }
  }

  if (isTranslationString) {
    return <>{renderFields}</>
  }

  return isLinksInField ? (
    <span className={classes.linkWrapper} onClick={handleClick}>
      <PrismicRichText field={renderFields} components={components} />
    </span>
  ) : (
    <PrismicRichText field={renderFields} components={components} />
  )
}

export default RichText
